module.exports = __webpack_public_path__ + "static/img/IMG_20241030_120458.5d293adf.jpg";